import * as z from "zod/v4";

/**
 * Machine-translates a spotlight block's authored strings into one or more
 * target languages, producing an editable "good start" for the merchant. Each
 * entry carries a caller-defined `key` (typically the element id + field) that
 * is echoed back so the client can map translations into the spotlight's
 * localization overlay.
 *
 * The input is tightly bounded so this LLM-backed endpoint (gated only by the
 * broad MANAGE_CAMPAIGNS permission) can't be driven into unbounded cost: a
 * single block only ever has a handful of translatable fields, and the picker
 * is restricted to the store's configured languages (a small set — the full
 * locale list is ~12).
 */
export const translateSpotlightBlock = {
  name: "translateSpotlightBlock" as const,
  input: z.object({
    entries: z
      .array(
        z.object({ key: z.string().max(200), message: z.string().max(5000) }),
      )
      .max(30),
    // ISO language codes to translate into (e.g. "fr", "es").
    targetLanguages: z.array(z.string().max(35)).max(20),
  }),
  output: z.object({
    // language code → entry key → translated string
    translations: z.record(z.string(), z.record(z.string(), z.string())),
  }),
};
